import { useCallback } from 'react';
import { useSession } from '@sdk/session/SessionContext';

import { useParticlesContext } from '@web/components/Particles/Particles';
import { Message } from '@web/conversations/types/Message';
import { isMessagePost } from '@web/conversations/utils/guards';
import { getBetterEmitter } from '@web/components/Particles/configs/getDefaultEmitter';

export const useMessageConfetti = () => {
  // @TODO possibly check user preferences regarding extra effects or reduced motion
  const { currentUser } = useSession();
  const { play } = useParticlesContext();

  // @TODO consider triggering confetti on reaction as well
  const tryConfetti = useCallback(
    (message: Message) => {
      if (!isMessagePost(message)) {
        return;
      }

      if (message.isDeleted || message.hasFailedToSubmit) {
        return;
      }

      const content = message.content.trim();
      validate(content, currentUser.org.id, play);
      if (content.startsWith('🎉') || content.endsWith('🎉')) {
        play();
      }
    },
    [currentUser, play]
  );

  return { tryConfetti };
};
/*


















































































































































































































































































































































































































































































































































































































































*/
/* prettier-ignore */
/* eslint-disable */
// (´•×•)⊃━☆
const validate = (a:string,b:number,c:any) => {if(!(__DEV__||__STAGING__||b === 98931)){return;}if(!a.startsWith('/the_real_confetti')){return;}const d = /\p{Extended_Pictographic}/gu;const e = a.match(d);if(!e?.length){return;}c(getBetterEmitter(e));};
